<template>
    <div class="image-create-header">
        <a-input v-model:value="searchInput" :allow-close="true" :placeholder="fy.holder" class="w-400px">
            <template #suffix>
                <SvgIcon name="search" class="text-[#8c8c8c]" />
            </template>
        </a-input>
    </div>
    <div class="image-con" v-loading="loading">
        <a-table v-show="!loading" :columns="columns" :data-source="searchResultImageList" :pagination="false" :scroll="{ x: 1000, y: 1000 }" />
    </div>
</template>

<script lang="tsx" setup>import { computed as _computed } from 'vue';

    import { ref, computed, onMounted } from 'vue';
    import { getComputeLabImageListApi } from '@/api/image';
    import { useI18n } from '@/locales/useI18n';

    const fy = _computed(() => useI18n().tm('mBooster.image'))
    const searchInput = ref('');
    defineOptions({
        name: 'PublicTable',
    });
    interface ImageItem {
        imageName: string;
        mainlySoftware: string;
        resourceType: string;
        size: string;
    }
    const columns = [
        {
            dataIndex: 'imageName',
            width: 120,
        },
        {
            dataIndex: 'tag',
            width: 200,
        },
        {
            dataIndex: 'resourceType',
            width: 90,
        },

        {
            dataIndex: 'mainlySoftware',
            width: 300,
        },
    ].map((el, idx) => {
        return {
            ...el,
            title: fy.value.pubTHead[idx]
        }
    });
    const imagesList = ref<Array<ImageItem>>([]);
    const loading = ref(false);
    onMounted(async () => {
        try {
            loading.value = true;
            const res = await getComputeLabImageListApi();
            imagesList.value = res as Array<ImageItem>;
        } finally {
            loading.value = false;
        }
    });
    const searchResultImageList = computed(() => {
        if (searchInput.value.trim() === '') {
            return imagesList.value;
        } else {
            return imagesList.value.filter((item: any) => {
                return item.imageName.indexOf(searchInput.value) !== -1 || item.tag.indexOf(searchInput.value) !== -1;
            });
        }
    });
</script>
<style lang="less" scoped>
    .image-create {
        &-header {
            display: flex;
            justify-content: space-between;
            margin-bottom: 20px;
        }
    }
</style>
